export function getLocalProgram() {
  return getItem('program', true);
}

export function setLocalProgram(program) {
  setItem('program', program, true);
}

export function removeLocalProgram() {
  removeItem('program');
}

export function getLocalLead() {
  return getItem('lead', true);
}

export function setLocalLead(lead) {
  setItem('lead', lead, true);
}

export function removeLocalLead() {
  removeItem('lead');
}

export function getLocalRegistration() {
  return getItem('registration', true);
}

export function setLocalRegistration(registration) {
  setItem('registration', registration, true);
}

export function getLocalAssociate() {
  return getItem('associate', true);
}

export function setLocalAssociate(associate) {
  setItem('associate', associate, true);
}

export function removeLocalRegistration() {
  removeItem('registration');
}

export function getLocalUserAuth() {
  return getItem('user-auth', true);
}

export function saveLocalUserAuth(userAuth) {
  setItem('user-auth', userAuth, true);
}

export function removeLocalUserAuth() {
  removeItem('user-auth');
}

export function getLocalCounter() {
  return getItem('counter', false);
}

export function setLocalCounter(counter) {
  setItem('counter', counter, false);
}

export function removeLocalCounter() {
  removeItem('lead');
}

function getItem(item, isObject) {
  const foundItem = localStorage.getItem(item);
  const newFoundItem = isObject ? JSON.parse(foundItem) : foundItem;
  if (!isValidStorageDate(newFoundItem)) {
    removeItem(item);
    return undefined;
  }
  return newFoundItem;
}

function setItem(item, value, isObject) {
  let newValue = value;
  if (isObject) {
    newValue = newValue || {};
    newValue.storageDate = new Date();
  }
  localStorage.setItem(item, isObject ? JSON.stringify(newValue) : newValue);
}

function removeItem(item) {
  localStorage.removeItem(item);
}

function isValidStorageDate(item) {
  if (item && item.storageDate) {
    const diff = new Date() - new Date(item.storageDate);
    if (diff > (1000 * 60 * 60 * 12)) {
      return false;
    }
  }
  return true;
}
